// ClubLinkPreviewRenderer — takes a message body and stacks a ClubLinkCard for
// each TransferPitch club/agency link it contains (parity #18). The sibling of
// ProfileCardPreviewRenderer; short-circuits to null when the text carries no
// club/agency link, so the common case costs ~nothing.

import React from "react";

import { detectClubLinks, hasClubLink } from "../../utils/clubLinkDetector";
import ClubLinkCard from "./ClubLinkCard";

export default function ClubLinkPreviewRenderer({ text }) {
  if (!hasClubLink(text)) return null;

  const matches = detectClubLinks(text);
  if (matches.length === 0) return null;

  return (
    <div
      className="tp-card-chat"
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      {matches.map((m) => (
        <ClubLinkCard
          key={`${m.type}:${m.id}:${m.index}`}
          type={m.type}
          id={m.id}
          fullUrl={m.fullUrl}
        />
      ))}
    </div>
  );
}
